module.exports = __webpack_public_path__ + "img/brand_logo.c2430696.png";